import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Statistics</Typography>

      <p>Comig soon...</p>
    </div>
  )
}

export default HelpText